module.exports = __webpack_public_path__ + "media/images/application/icons/playlist-932620264bf209978526fd74dc45b8f5.svg";